/// <amd-module name="typeahead/core/util/HandlebarHelperUtils" />

export class HandlebarHelperUtils {
    /*
    al refers to alias, e.g for New York it is "Big Apple".
    ap refers to the airport name string, e.g. "(NYC - All Airports)"
    the point of the tags is:
    1. tech debt: have a better way to parse data from the server rather than using paren position. in the future we
    would ideally have all parsing based on tags rather than position.
    2. support flights variant 2: so we can distinguish ap and al from each other (is in a different order depending
    on serverside bucketing and may have "extra text" in between)
     */
    public static alOpenTag: string = "<al>";
    public static alCloseTag: string = "</al>";
    public static apOpenTag: string = "<ap>";
    public static apCloseTag: string = "</ap>";

    // expected input is "<ap>...</ap>". output depends on rearrange but should still be tagged
    public static formatApText(apText: string, rearrange: boolean): string {
        if (apText.indexOf(HandlebarHelperUtils.apOpenTag) !== -1) {
            apText = apText.replace(HandlebarHelperUtils.apOpenTag
                + "(", "").replace(")" + HandlebarHelperUtils.apCloseTag, "");

            let dashIndex: number = apText.indexOf("-");
            let tla = "";
            let rest = "";

            if (dashIndex !== -1) {
                tla = apText.substring(0, dashIndex).trim();
                rest = apText.substring(dashIndex + 1, apText.length);
            } else {
                tla = apText;
                rest = "";
            }

            if (rearrange) {    // output: "(<B>NYC</B>) - All Airports"
                apText = "(<B>" + tla + "</B>)" + rest;
            } else {            // output: "(<B>NYC</B> - All Airports)"
                apText = "(" + apText.replace(tla, "<B>" + tla + "</B>") + ")";
            }

            apText = HandlebarHelperUtils.apOpenTag + apText + HandlebarHelperUtils.apCloseTag;
        }
        return apText;
    }

    public static convertApAlTaggedMainToMultiLineHtml(textHtml) {
        let apOpenStartIndex: number = textHtml.indexOf(HandlebarHelperUtils.apOpenTag);
        let apCloseStartIndex: number = textHtml.indexOf(HandlebarHelperUtils.apCloseTag);
        let alOpenStartIndex: number = textHtml.indexOf(HandlebarHelperUtils.alOpenTag);
        let alCloseStartIndex: number = textHtml.indexOf(HandlebarHelperUtils.alCloseTag);

        let isApTagFirst: boolean = apOpenStartIndex < alOpenStartIndex;
        let leadingText: string = textHtml.substring(0, isApTagFirst ? apOpenStartIndex : alOpenStartIndex);
        let extraText = ""; // if present, seems to only be the near string
        // textHtml element ordering changes depending on serverside bucket
        if (isApTagFirst) {
            extraText = textHtml.substring(
                apCloseStartIndex + HandlebarHelperUtils.apCloseTag.length, alOpenStartIndex);
        } else {
            extraText = textHtml.substring(apCloseStartIndex + HandlebarHelperUtils.apCloseTag.length, textHtml.length);
        }

        let apText: string = textHtml.substring(
            apOpenStartIndex, apCloseStartIndex + HandlebarHelperUtils.apCloseTag.length);
        let alText: string = textHtml.substring(
            alOpenStartIndex, alCloseStartIndex + HandlebarHelperUtils.alCloseTag.length);

        let result: string = textHtml;
        if (isApTagFirst) {
            result = this.createMultiLineHtmlWrapped(leadingText + extraText,
                this.formatApText(apText, false), this.addAlVariantTwoStyleToTags(alText));
        } else {
            result = this.createMultiLineHtmlWrapped(leadingText + alText, extraText,
                this.formatApText(apText, true));
        }
        return result;
    }

    // it looks like currently there's no custom css for uta. this is a temporary workaround
    public static addAlVariantTwoStyleToTags(textHtml) {
        if (this.isAlTagged(textHtml)) {
            let styledAl: string = `<al style="font-weight:bold;font-size:12px;color:black">`;
            textHtml = textHtml.replace("(", "").replace(")", "");
            textHtml = textHtml.replace(HandlebarHelperUtils.alOpenTag, styledAl);
        }
        return textHtml;
    }

    public static isAlTagged(html) {
        return html.indexOf(HandlebarHelperUtils.alOpenTag) !== -1
            && html.indexOf(HandlebarHelperUtils.alCloseTag) !== -1;
    }

    public static isApTagged(html) {
        return html.indexOf(HandlebarHelperUtils.apOpenTag) !== -1
            && html.indexOf(HandlebarHelperUtils.apCloseTag) !== -1;
    }

    public static isApAlTagged(html) {
        return this.isApTagged(html) && this.isAlTagged(html);
    }

    // identical to createMultiLineHtml except it fixes the text wrap issue
    public static createMultiLineHtmlWrapped(topLeft, topRight, bottom) {
        let html: string = "<div class='multiLineDisplay details' style='width:100%'>";
        html += topLeft.trim();
        if (topRight) {
            html += " " + topRight.trim();
        }
        if (bottom) {
            html += "<br>" + bottom.trim();
        }
        html += "</div>";
        return html;
    }

    public static createMultiLineHtml(topLeft, topRight, bottom) {
        let html: string = "<div class='multiLineDisplay'>";
        html += topLeft.trim();
        if (topRight) {
            html += " " + topRight.trim();
        }
        if (bottom) {
            html += "<br>" + bottom.trim();
        }
        html += "</div>";
        return html;
    }
}
